import { Link } from "react-router-dom";
import { IconButton, Skeleton, SliceBorder } from "../../../../shared/ui";

import { generateMediaQuery, searchQueryURL, transferDanglingPrepositions } from "../../../../shared/lib/helpers";
import { CareerBackInterfacesDTODirectionDirectionDto } from "../../../../shared/ApiContract/data-contracts";
import { RoutesEnum } from "../../../../shared/constants/routes";
import { useMediaQuery } from "../../../../shared/hooks/useMediaQuery";
import { MediaQueryProperty, MediaSizeEnum } from "../../../../shared/constants/media";

import styles from "./DirectionCard.module.scss";
import { classNames } from "../../../../shared/lib/classNames";
import { API_URL } from "../../../../shared/constants/api";

import type { FC } from "react";

interface JobCardProps {
    itemJob: CareerBackInterfacesDTODirectionDirectionDto;
}

export const DirectionCard: FC<JobCardProps> = ({ itemJob }) => {
    const isTablet = useMediaQuery(
        `(${MediaQueryProperty.MinWidth}: ${MediaSizeEnum.sm}) and (${MediaQueryProperty.MaxWidth}: ${MediaSizeEnum.lg})`,
    );

    return (
        <div className={styles.job} style={{ backgroundImage: `url(${API_URL}/static/${itemJob.iconName}.png)` }}>
            <Link to={searchQueryURL(RoutesEnum.Direction, { directionId: itemJob.id })}>
                <div className={styles.job__container}>
                    <p
                        className={classNames({
                            cls: styles.job__title,
                        })}
                        lang="ru"
                        dangerouslySetInnerHTML={{ __html: transferDanglingPrepositions(itemJob.name!) }}
                    />
                    <SliceBorder
                        className={styles.job__wrapperButton}
                        sizeRadius={isTablet ? 14 : 18}
                        multiplierInside={isTablet ? 1 : 2}
                        border={{
                            bottomRight: "outside-corner-upper",
                            bottomLeft: "inside",
                            topLeft: "outside-corner-lateral",
                        }}
                    >
                        <IconButton theme="dark" icon="rightTop" />
                    </SliceBorder>
                </div>
            </Link>
        </div>
    );
};

export const DirectionCardSkeleton = () => {
    return <Skeleton className={styles.job__skeleton} />;
};
